/**
 *
 * @name app.infrastructure:EventBusModule
 * @date
 * @copyright 2015 Empower Retirement
 * @description
 *
 *      Makes the event bus service and exports it to the globalThis window object.
 */
import "angular";
import EventBus from "./EventBus";
import eventBusRun from "./EventBusRun";

var moduleDependencies = [];

const EventBusModule = angular.module('EventBusModule', moduleDependencies )
	.run(eventBusRun)
    .factory( "eventBus", EventBus);

export default EventBusModule;
